// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"454":"f4cae7c3","741":"129055e1","878":"f4cae7c3"}[chunkId] + ".css";
};